import { useAnalytics } from '@r-client/shared/data/analytics';

import { RSpaxBanner } from './r-spax-banner';

export const MirrorTokensBanner = () => {
  const analytics = useAnalytics();

  const onBannerClick = () => {
    analytics.track({
      name: 'promo_flash_banner_clicked',
      params: {
        label: 'mirror_tokens_banner',
      },
    });
  };

  return <RSpaxBanner onBannerClick={onBannerClick} />;
};
